import styled from "styled-components";
import CustomTextBox from "../CustomTextBox/CustomTextBox";
import { defaultRegex } from "../../Regex";

const BodyWrapper = styled.div`
  text-align: left;

  .inputBoxSection {
    margin: 1em;
  }
`;

const SelectCustodianForm = ({
  handleCustomTextBoxOnBlur,
  handleCustomTextBoxKeyPress,
}) => {
  return (
    <BodyWrapper>
      <div className="inputBoxSection">
        <CustomTextBox
          placeholder="Name of Custodian"
          name="custodianName"
          errorMessage="Wrong name of custodian"
          regexCode={defaultRegex}
          onBlur={handleCustomTextBoxOnBlur}
          onKeyPress={handleCustomTextBoxKeyPress}
        />
      </div>
    </BodyWrapper>
  );
};

export default SelectCustodianForm;
